import React, { useEffect, useState } from 'react';

import ExploreLinks from './components/ExploreLinks';
import Form from './components/Form';
import SearchBlock from './components/SearchBlock';

import useAlgolia from '../../hooks/useAlgolia';
import useModal from '../../hooks/useModal';

import {
  Container,
  Content,
  Header,
  Modal,
  Wrapper,
  Overlay,
} from './styles/index.styled';

const SiteSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { closeModal, isOpen } = useModal();

  const {
    search: algoliaSearch,
    searchResponse: algoliaResponse,
    loading: algoliaLoading,
  } = useAlgolia('upkeep_site_2025', searchQuery);

  const uniqueHits = algoliaResponse?.hits.filter(
    (v, i, a) => a.findIndex(t => t.title === v.title) === i
  );

  useEffect(() => {
    const handleEscKey = e => {
      if (e.key === 'Escape' && searchQuery === '') {
        closeModal();
        return;
      }

      if (e.key === 'Escape') {
        setSearchQuery('');
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, searchQuery, closeModal]);

  return (
    <Modal isOpen={isOpen} tabIndex={0}>
      <Overlay isOpen={isOpen} onClick={closeModal} />
      <Container>
        <Wrapper>
          <Header>
            <Form
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              closeModal={closeModal}
            />
          </Header>
          <Content>
            {!searchQuery && <ExploreLinks />}
            {searchQuery && (
              <SearchBlock
                list={uniqueHits}
                loading={algoliaLoading}
                searchQuery={searchQuery}
                uniqueHits={uniqueHits}
              />
            )}
          </Content>
        </Wrapper>
      </Container>
    </Modal>
  );
};

export default SiteSearch;
